export enum ComponentId {
  DESCRIPTION = "description",
  ADDITIONAL_IMAGES = "ocVehicleDamages",
  BACK_IMAGE = "backImage",
  DAMAGE_IMAGES = "ocVehicleDamages",
  FRONT_IMAGE = "frontImage",
}
